import { render, staticRenderFns } from "./IllustrationDes.vue?vue&type=template&id=fe179bf6&scoped=true"
import script from "./IllustrationDes.vue?vue&type=script&lang=js"
export * from "./IllustrationDes.vue?vue&type=script&lang=js"
import style0 from "./IllustrationDes.vue?vue&type=style&index=0&id=fe179bf6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe179bf6",
  null
  
)

export default component.exports